import Api from '../_base';

class PharmaceuticalApi {
	async getPharmaceuticalUnitsList() {
		try {
			const response = await Api.get('/pharmaceutical/units', false);
			return {
				data: response.data,
				status: response.status,
				statusText: response.statusText
			};
		} catch (error) {
			console.error("Erro na requisição API:", error);
			throw error;
		}
	}
}

export default new PharmaceuticalApi();
